import { render, staticRenderFns } from "./MovimentarEstoque.vue?vue&type=template&id=45bb8b6a&"
import script from "./MovimentarEstoque.vue?vue&type=script&lang=js&"
export * from "./MovimentarEstoque.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports